export const localNames = {
    isTop: 'sy_em_isTop',
    pageset: 'sy_em_pageset',
    sharpflatModel: 'sy_em_sharpflat_model',
    vocalsModel: 'sy_em_vocals_model',
    emValueModel: 'sy_em_value_model',
    isAiFirst: 'sy_is_ai_first',
    emShortcut: 'sy_em_shortcut',
    shortcutLink: 'sy_shortcut_link',
    isSetShortcutByEmModel: 'sy_is_set_shortcut_by_em_model',
    emModelShortcut: 'sy_em_model_shortcut',
    emValue: 'sy_em_value',
    emPluginModel: 'sy_em_plugin_model',
    isEnableAudioFFT: 'sy_is_enable_audio_fft',
    componentNotFree: 'sy_component_not_free',
    rate: 'sy_em_rate_pre',
    humanize: 'sy_em_humanize_pre',
    flex: 'sy_em_flex_pre',
    tracking: 'sy_em_tracking_pre',
    vibrato: 'sy_em_vibrato_pre',
    linkage: 'sy_em_linkage',
    kugouEffectTipDisable: 'sy_kugou_effect_tip_disable',
    accModel: 'sy_acc_model',
}

// 设置置顶
export const setIsTop = (f) => {
    window.localStorage.setItem(localNames.isTop, f)
}
// 获取置顶
export const getIsTop = (uiExtConf) => {
    const local = JSON.parse(window.localStorage.getItem(localNames.isTop))
    if (typeof local === 'boolean') {
        return local
    }
    if (!uiExtConf || !isExist('isTop', uiExtConf)) {
        return false
    }
    return !!uiExtConf.isTop
}
// 设置页面配置
export const setPageset = (pageset) => {
    window.localStorage.setItem(localNames.pageset, JSON.stringify(pageset))
}
// 获取页面配置
export const getPageset = (pageset, uiExtConf) => {
    const local = JSON.parse(window.localStorage.getItem(localNames.pageset))
    const result = {}
    if (local !== null) {
        for (const key in pageset) {
            result[key] = typeof local[key] === 'boolean' ? local[key] : pageset[key]
        }
        return result
    } else if (uiExtConf && uiExtConf.pageset) {
        for (const key in pageset) {
            result[key] = isExist(key, uiExtConf.pageset) ? Boolean(uiExtConf.pageset[key].show) : pageset[key]
        }
        return result
    }
    return pageset
}

// 获取电音默认参数
export const getDefaultEmValue = (uiExtConf, model) => {
    const local = JSON.parse(window.localStorage.getItem(localNames.emValue))
    const defaultEmValue = {
        rate: 0,
        humanize: 0,
        flex: 0,
        vibrato: 0,
        tracking: 0,
    }
    if (checkPreset(uiExtConf.rate)) {
        defaultEmValue.rate = uiExtConf.rate.value
    }
    if (checkPreset(uiExtConf.humanize)) {
        defaultEmValue.humanize = uiExtConf.humanize.value
    }
    if (checkPreset(uiExtConf.flex)) {
        defaultEmValue.flex = uiExtConf.flex.value
    }
    if (checkPreset(uiExtConf.vibrato)) {
        defaultEmValue.vibrato = uiExtConf.vibrato.value
    }
    if (checkPreset(uiExtConf.tracking)) {
        defaultEmValue.tracking = uiExtConf.tracking.value
    }
    if (local !== null && model === 'lock') {
        // return { ...defaultEmValue, ...local }
        return Object.assign(defaultEmValue, local)
    } else {
        return defaultEmValue
    }
}
// 设置电音默认参数
export const setDefaultEmValue = (emvalue) => {
    window.localStorage.setItem(localNames.emValue, JSON.stringify(emvalue))
}

// 获取电音精调快捷选项
export const getEmShortcut = (DefaultEmShortcut, uiExtConf) => {
    const local = JSON.parse(window.localStorage.getItem(localNames.emShortcut));
    const result = {}
    if (local !== null) {
        for (const key in DefaultEmShortcut) {
            result[key] = isExist(key, local) ? local[key] : DefaultEmShortcut[key];
        }
        return result
    } else if (uiExtConf && uiExtConf.shortcut) {
        for (const key in DefaultEmShortcut) {
            result[key] = isExist(key, uiExtConf.shortcut) ? uiExtConf.shortcut[key] : DefaultEmShortcut[key]
        }
        return result
    }
    return result
}
// 设置电音精调快捷选项
export const setEmShortcut = (emShortcut) => {
    window.localStorage.setItem(localNames.emShortcut, JSON.stringify(emShortcut))
}

// 获取电音模式的快捷键关联选项
export const getEmModelShortcut = (DefaultEmModelShortcut, uiExtConf) => {
    const local = JSON.parse(window.localStorage.getItem(localNames.emModelShortcut));
    const result = {}
    if (local !== null) {
        for (const key in DefaultEmModelShortcut) {
            result[key] = isExist(key, local) ? local[key] : DefaultEmModelShortcut[key];
        }
        return result
    } else if (uiExtConf && uiExtConf.emModelShortcut) {
        for (const key in DefaultEmModelShortcut) {
            result[key] = isExist(key, uiExtConf.emModelShortcut) ? uiExtConf.emModelShortcut[key] : DefaultEmModelShortcut[key]
        }
        return result
    }
    return DefaultEmModelShortcut
}
// 设置电音模式的快捷键关联选项
export const setEmModelShortcut = (emModelShortcut) => {
    window.localStorage.setItem(localNames.emModelShortcut, JSON.stringify(emModelShortcut))
}

// 获取是否通过电音模式关联快捷键
export const getIsSetShortcutByEmModel = (uiExtConf) => {
    const local = window.localStorage.getItem(localNames.isSetShortcutByEmModel);
    if (local !== null) {
        return local === "true";
    }
    return !!uiExtConf.isSetShortcutByEmModel;
}
// 设置是否通过电音模式关联快捷键
export const setIsSetShortcutByEmModel = (isLink) => {
    window.localStorage.setItem(localNames.isSetShortcutByEmModel, isLink);
}

// 获取电音精调关联选项
export const getShortcutLink = (DefaultShortcutLink, uiExtConf) => {
    const local = JSON.parse(window.localStorage.getItem(localNames.shortcutLink));
    const result = {}
    if (local !== null) {
        for (const key in DefaultShortcutLink) {
            result[key] = typeof local[key] === 'boolean' ? local[key] : DefaultShortcutLink[key];
        }
        return result
    } else if (uiExtConf && uiExtConf.shortcutLink) {
        for (const key in DefaultShortcutLink) {
            result[key] = isExist(key, uiExtConf.shortcutLink) ? Boolean(uiExtConf.shortcutLink[key]) : DefaultShortcutLink[key]
        }
        return result
    }
    return DefaultShortcutLink
}
// 设置电音精调关联选项
export const setShortcutLink = (shortcutLink) => {
    window.localStorage.setItem(localNames.shortcutLink, JSON.stringify(shortcutLink))
}

// 设置升降调模式
export const setSharpflatModel = (model) => {
    if (!['reset', 'renew', 'lock'].includes(model)) {
        model = 'renew'
    }
    window.localStorage.setItem(localNames.sharpflatModel, model)
}
// 获取升降调模式
export const getSharpflatModel = () => {
    const model = window.localStorage.getItem(localNames.sharpflatModel)
    if (['reset', 'renew', 'lock'].includes(model)) {
        return model
    }
    return 'renew'
}

// 设置消人声模式
export const setVocalsModel = (model) => {
    if (!['reset', 'renew', 'lock'].includes(model)) {
        model = 'reset'
    }
    window.localStorage.setItem(localNames.vocalsModel, model)
}
// 获取消人声模式
export const getVocalsModel = () => {
    const model = window.localStorage.getItem(localNames.vocalsModel)
    if (['reset', 'renew', 'lock'].includes(model)) {
        return model
    }
    return 'reset'
}

// 设置电音参数模式
export const setEmValueModel = (model) => {
    if (!['reset', 'renew', 'lock'].includes(model)) {
        model = 'lock'
    }
    window.localStorage.setItem(localNames.emValueModel, model)
}
// 获取电音参数模式
export const getEmValueModel = () => {
    const model = window.localStorage.getItem(localNames.emValueModel)
    if (['reset', 'renew', 'lock'].includes(model)) {
        return model
    }
    return 'lock'
}
// 设置电音插件模式
export const setEmPluginModel = (obj) => {
    window.localStorage.setItem(localNames.emPluginModel, JSON.stringify(obj))
}
// 获取电音插件模式
export const getEmPluginModel = () => {
    const obj = JSON.parse(window.localStorage.getItem(localNames.emPluginModel))
    if (obj) {
        return obj;
    }
    return {
        name: '默认',
        value: 'soprano',
    }
}

// 电音模式的三个名称（默认「男/女高音」这类中性叫法，后台可改）
export const EM_MODEL_DEFAULT_NAMES = {
    soprano: '男/女高音',
    alto: '男/女中音',
    lowMale: '男/女低音',
}
export const getEmModelNames = (uiExtConf) => {
    const result = Object.assign({}, EM_MODEL_DEFAULT_NAMES)
    const conf = uiExtConf && uiExtConf.emModelNames
    if (conf) {
        Object.keys(EM_MODEL_DEFAULT_NAMES).forEach((k) => {
            if (typeof conf[k] === 'string' && conf[k].trim()) {
                result[k] = conf[k].trim()
            }
        })
    }
    return result
}

/* 界面文案（后台可改）：
   subTitle/subTip = 「其他可尝试的基调」「请选择适合自己的」卡片
   aiEmptyTitle/aiEmptyTip = AI 分析没拿到音频时那两行 */
export const EM_TEXT_DEFAULT = {
    subTitle: '其他可尝试的基调',
    subTip: '请选择适合自己的',
    aiEmptyTitle: 'AI分析未采集到音频信号',
    aiEmptyTip: '请选择正在使用的播放器',
}
export const getEmTexts = (uiExtConf) => {
    const result = Object.assign({}, EM_TEXT_DEFAULT)
    const conf = uiExtConf && uiExtConf.texts
    if (conf) {
        Object.keys(EM_TEXT_DEFAULT).forEach((k) => {
            if (typeof conf[k] === 'string' && conf[k].trim()) {
                result[k] = conf[k].trim()
            }
        })
    }
    return result
}

// 播放器能力表：每个功能一个模式
//   support = 显示控件 / hint = 显示提示文字 / acc = 显示「切换伴奏助手」/ hide = 不显示
// 后台可改（后台「电音精调默认值 → 播放器能力」）
export const PLAYER_CAPS_DEFAULT = {
    kugou: { tune: 'support', vocals: 'support', hint: '' },
    qq: { tune: 'support', vocals: 'support', hint: '' },
    kuwo: { tune: 'support', vocals: 'support', hint: '' },
    wesing: { tune: 'hint', vocals: 'hide', hint: '请在全民K歌内升降调' },
    netease: { tune: 'acc', vocals: 'acc', hint: '' },
    soda: { tune: 'acc', vocals: 'acc', hint: '' },
    baidu: { tune: 'acc', vocals: 'acc', hint: '' },
    xiami: { tune: 'acc', vocals: 'acc', hint: '' },
    fanxing: { tune: 'acc', vocals: 'acc', hint: '' },
    mvbox: { tune: 'acc', vocals: 'acc', hint: '' },
    foobar: { tune: 'acc', vocals: 'acc', hint: '' },
    __default: { tune: 'acc', vocals: 'acc', hint: '' },
}

const CAP_MODES = ['support', 'hint', 'acc', 'hide']
const normCapMode = (v) => {
    if (v === true) return 'support'
    if (v === false) return 'acc'
    return CAP_MODES.indexOf(v) >= 0 ? v : 'acc'
}

export const getPlayerCaps = (uiExtConf) => {
    const table = {}
    Object.keys(PLAYER_CAPS_DEFAULT).forEach((k) => {
        table[k] = Object.assign({}, PLAYER_CAPS_DEFAULT[k])
    })
    const conf = uiExtConf && uiExtConf.playerCaps
    if (conf) {
        Object.keys(conf).forEach((k) => {
            const src = conf[k]
            if (!src || typeof src !== 'object') return
            const target = table[k] || (table[k] = { tune: 'acc', vocals: 'acc', hint: '' })
            if (src.tune !== undefined) target.tune = normCapMode(src.tune)
            if (src.vocals !== undefined) target.vocals = normCapMode(src.vocals)
            if (typeof src.hint === 'string') target.hint = src.hint
        })
    }
    return table
}

// 取某个播放器的能力，未知播放器走 __default
export const getPlayerCap = (table, player) => {
    const src = (table && table[player]) || (table && table.__default) || PLAYER_CAPS_DEFAULT.__default
    return {
        tune: normCapMode(src.tune),
        vocals: normCapMode(src.vocals),
        hint: src.hint || '',
    }
}

// 获取是否AI寄到优先
export const getIsAiFirst = () => {
    return window.localStorage.getItem(localNames.isAiFirst) === "true"
}
// 设置是否AI基调优先
export const setIsAiFirst = (isAiFirst) => {
    window.localStorage.setItem(localNames.isAiFirst, isAiFirst)
}

// 获取是否启动播放器频谱
export const getIsSetEnableAudioFFT = () => {
    const local = window.localStorage.getItem(localNames.isEnableAudioFFT);
    if (local !== null) {
        return local === "true";
    }
    return true
}
// 设置是否启动播放器频谱
export const setIsSetEnableAudioFFT  = (enable) => {
    window.localStorage.setItem(localNames.isEnableAudioFFT, enable);
}
// 获取是否释放组件
export const getComponentNotFree = () => {
    const local = window.localStorage.getItem(localNames.componentNotFree);
    if (local !== null) {
        return local === "true";
    }
    return false
}
// 设置是否释放组件
export const setComponentNotFree = (enable) => {
    window.localStorage.setItem(localNames.componentNotFree, enable);
}

// 获取电音速率预配置
export const getRatePre = (defaultPre, uiExtConf) => {
    const local = JSON.parse(window.localStorage.getItem(localNames.rate));
    return getEmValuePre(local, 'rate', defaultPre, uiExtConf);
}
// 设置电音速率预配置
export const setRatePre = (pre) => {
    window.localStorage.setItem(localNames.rate, JSON.stringify(pre))
}
// 获取电音拟人预配置
export const getHumanizePre = (defaultPre, uiExtConf) => {
    const local = JSON.parse(window.localStorage.getItem(localNames.humanize));
    return getEmValuePre(local, 'humanize', defaultPre, uiExtConf);
}
// 设置电音拟人预配置
export const setHumanizePre = (pre) => {
    window.localStorage.setItem(localNames.humanize, JSON.stringify(pre))
}
// 获取电音颤音预配置
export const getVibratoPre = (defaultPre, uiExtConf) => {
    const local = JSON.parse(window.localStorage.getItem(localNames.vibrato));
    return getEmValuePre(local, 'vibrato', defaultPre, uiExtConf);
}
// 设置电音颤音预配置
export const setVibratoPre = (pre) => {
    window.localStorage.setItem(localNames.vibrato, JSON.stringify(pre))
}
// 获取电音弹性预配置
export const getFlexPre = (defaultPre, uiExtConf) => {
    const local = JSON.parse(window.localStorage.getItem(localNames.flex));
    return getEmValuePre(local, 'flex', defaultPre, uiExtConf);
}
// 设置电音弹性预配置
export const setFlexPre = (pre) => {
    window.localStorage.setItem(localNames.flex, JSON.stringify(pre))
}
// 获取电音跟踪预配置
export const getTrackingPre = (defaultPre, uiExtConf) => {
    const local = JSON.parse(window.localStorage.getItem(localNames.tracking));
    return getEmValuePre(local, 'tracking', defaultPre, uiExtConf);
}
// 设置电音跟踪预配置
export const setTrackingPre = (pre) => {
    window.localStorage.setItem(localNames.tracking, JSON.stringify(pre))
}
function getEmValuePre(local, type, defaultPre, uiExtConf) {
    const result = {}
    if (local !== null) {
        for (const key in defaultPre) {
            result[key] = isExist(key, local) ? local[key] : defaultPre[key];
        }
        return result
    } else if (uiExtConf && uiExtConf[type]) {
        for (const key in defaultPre) {
            result[key] = isExist(key, uiExtConf[type]) ? uiExtConf[type][key] : defaultPre[key]
        }
        return result
    }
    return defaultPre
}

// 获取联动调节配置
export const getEmLinkage = (defaultLinkage, uiExtConf) => {
    const local = JSON.parse(window.localStorage.getItem(localNames.linkage));
    return getEmValuePre(local, 'emLinkage', defaultLinkage, uiExtConf);
}
// 设置联动调节配置
export const setEmLinkage = (pre) => {
    window.localStorage.setItem(localNames.linkage, JSON.stringify(pre))
}

// 获取是否禁用酷狗效果提示
export const getKugouEffectTipDisable = () => {
    return window.localStorage.getItem(localNames.kugouEffectTipDisable) === "true"
}
// 设置是否禁用酷狗效果提示
export const setKugouEffectTipDisable = (kugouEffectTipDisable) => {
    window.localStorage.setItem(localNames.kugouEffectTipDisable, kugouEffectTipDisable)
}

// 获取伴奏模式
export const getLocalAccModel = () => {
    const accModel = window.localStorage.getItem(localNames.accModel)
    return ["播放器", "伴奏助手"].includes(accModel) ? accModel : '播放器';
}
// 设置伴奏模式
export const setLocalAccModel = (accModel) => {
    window.localStorage.setItem(localNames.accModel, accModel);
}

function checkPreset(cnf) {
    return cnf && cnf.name && typeof cnf.value === 'number'
}
function isExist(key, obj) {
    return key in obj
}

// 删除所有本地设置
export const clearLocalStorage = () => {
    // clear有BUG 采用覆盖重写  去掉sy_em_cache
    for (const key in localNames) {
        window.localStorage.setItem(localNames[key], null);
    }
}
